import React from 'react';
import Icon from '../../../components/AppIcon';

const ChannelSidebar = ({ activeChannel, onChannelChange }) => {
  const channels = [
    {
      id: 'whatsapp',
      name: 'واتساب',
      icon: 'MessageCircle',
      unreadCount: 8,
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      id: 'internal',
      name: 'رسائل داخلية',
      icon: 'Mail',
      unreadCount: 3,
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'email',
      name: 'البريد الإلكتروني',
      icon: 'Inbox',
      unreadCount: 12,
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'automated',
      name: 'الردود الآلية',
      icon: 'Bot',
      unreadCount: 0,
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      id: 'scheduled',
      name: 'المتابعات المجدولة',
      icon: 'Calendar',
      unreadCount: 5,
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  const quickActions = [
    { id: 'new-message', label: 'رسالة جديدة', icon: 'Plus' },
    { id: 'bulk-send', label: 'إرسال جماعي', icon: 'Send' },
    { id: 'templates', label: 'القوالب', icon: 'FileText' }
  ];

  return (
    <div className="h-full flex flex-col bg-card border-l border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-3 md:mb-4">
          قنوات التواصل
        </h3>
        <div className="space-y-1 md:space-y-2">
          <button
            onClick={() => onChannelChange('whatsapp')}
            className={`w-full flex items-center justify-between p-2 md:p-3 rounded-lg transition-all duration-250 ${
              activeChannel === 'whatsapp' ?'bg-primary text-primary-foreground shadow-warm' :'hover:bg-muted text-foreground'
            }`}
          >
            <div className="flex items-center gap-2 md:gap-3">
              <div className={`p-1.5 md:p-2 rounded-lg ${activeChannel === 'whatsapp' ? 'bg-primary-foreground/20' : 'bg-green-500/10'}`}>
                <Icon
                  name="MessageCircle"
                  size={16}
                  className={activeChannel === 'whatsapp' ? 'text-primary-foreground' : 'text-green-500'}
                />
              </div>
              <span className="text-sm md:text-base font-medium">واتساب</span>
            </div>
            <span className={`px-1.5 md:px-2 py-0.5 md:py-1 rounded-full text-xs font-medium ${
              activeChannel === 'whatsapp' ?'bg-primary-foreground text-primary' :'bg-error text-error-foreground'
            }`}>
              12
            </span>
          </button>
          <button
            onClick={() => onChannelChange('email')}
            className={`w-full flex items-center justify-between p-2 md:p-3 rounded-lg transition-all duration-250 ${
              activeChannel === 'email' ?'bg-primary text-primary-foreground shadow-warm' :'hover:bg-muted text-foreground'
            }`}
          >
            <div className="flex items-center gap-2 md:gap-3">
              <div className={`p-1.5 md:p-2 rounded-lg ${activeChannel === 'email' ? 'bg-primary-foreground/20' : 'bg-blue-500/10'}`}>
                <Icon
                  name="Mail"
                  size={16}
                  className={activeChannel === 'email' ? 'text-primary-foreground' : 'text-blue-500'}
                />
              </div>
              <span className="text-sm md:text-base font-medium">البريد الإلكتروني</span>
            </div>
            <span className={`px-1.5 md:px-2 py-0.5 md:py-1 rounded-full text-xs font-medium ${
              activeChannel === 'email' ?'bg-primary-foreground text-primary' :'bg-error text-error-foreground'
            }`}>
              5
            </span>
          </button>
          <button
            onClick={() => onChannelChange('sms')}
            className={`w-full flex items-center justify-between p-2 md:p-3 rounded-lg transition-all duration-250 ${
              activeChannel === 'sms' ?'bg-primary text-primary-foreground shadow-warm' :'hover:bg-muted text-foreground'
            }`}
          >
            <div className="flex items-center gap-2 md:gap-3">
              <div className={`p-1.5 md:p-2 rounded-lg ${activeChannel === 'sms' ? 'bg-primary-foreground/20' : 'bg-purple-500/10'}`}>
                <Icon
                  name="MessageSquare"
                  size={16}
                  className={activeChannel === 'sms' ? 'text-primary-foreground' : 'text-purple-500'}
                />
              </div>
              <span className="text-sm md:text-base font-medium">رسائل SMS</span>
            </div>
            <span className={`px-1.5 md:px-2 py-0.5 md:py-1 rounded-full text-xs font-medium ${
              activeChannel === 'sms' ?'bg-primary-foreground text-primary' :'bg-error text-error-foreground'
            }`}>
              3
            </span>
          </button>
          <button
            onClick={() => onChannelChange('phone')}
            className={`w-full flex items-center justify-between p-2 md:p-3 rounded-lg transition-all duration-250 ${
              activeChannel === 'phone' ?'bg-primary text-primary-foreground shadow-warm' :'hover:bg-muted text-foreground'
            }`}
          >
            <div className="flex items-center gap-2 md:gap-3">
              <div className={`p-1.5 md:p-2 rounded-lg ${activeChannel === 'phone' ? 'bg-primary-foreground/20' : 'bg-orange-500/10'}`}>
                <Icon
                  name="Phone"
                  size={16}
                  className={activeChannel === 'phone' ? 'text-primary-foreground' : 'text-orange-500'}
                />
              </div>
              <span className="text-sm md:text-base font-medium">المكالمات</span>
            </div>
          </button>
        </div>
      </div>
      <div className="p-4 md:p-6 border-b border-border">
        <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-2 md:mb-3">
          إجراءات سريعة
        </h4>
        <div className="space-y-1 md:space-y-2">
          <button
            className="w-full flex items-center gap-2 md:gap-3 p-2 md:p-2.5 rounded-lg hover:bg-muted transition-all duration-250 text-foreground"
          >
            <Icon name="UserPlus" size={16} className="text-primary" />
            <span className="text-sm md:text-base">إضافة عميل جديد</span>
          </button>
          <button
            className="w-full flex items-center gap-2 md:gap-3 p-2 md:p-2.5 rounded-lg hover:bg-muted transition-all duration-250 text-foreground"
          >
            <Icon name="Send" size={16} className="text-primary" />
            <span className="text-sm md:text-base">إرسال رسالة جماعية</span>
          </button>
          <button
            className="w-full flex items-center gap-2 md:gap-3 p-2 md:p-2.5 rounded-lg hover:bg-muted transition-all duration-250 text-foreground"
          >
            <Icon name="Calendar" size={16} className="text-primary" />
            <span className="text-sm md:text-base">جدولة موعد</span>
          </button>
          <button
            className="w-full flex items-center gap-2 md:gap-3 p-2 md:p-2.5 rounded-lg hover:bg-muted transition-all duration-250 text-foreground"
          >
            <Icon name="FileText" size={16} className="text-primary" />
            <span className="text-sm md:text-base">إنشاء عقد</span>
          </button>
        </div>
      </div>
      <div className="flex-1 p-4 md:p-6 overflow-y-auto">
        <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-2 md:mb-3">
          الإحصائيات
        </h4>
        <div className="space-y-2 md:space-y-3">
          <div className="p-2 md:p-3 rounded-lg bg-muted">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs md:text-sm text-muted-foreground font-caption">الرسائل اليوم</span>
              <span className="text-base md:text-lg font-heading font-semibold text-foreground">47</span>
            </div>
            <div className="w-full h-1.5 md:h-2 bg-background rounded-full overflow-hidden">
              <div className="h-full bg-primary rounded-full" style={{ width: '68%' }} />
            </div>
          </div>
          <div className="p-2 md:p-3 rounded-lg bg-muted">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs md:text-sm text-muted-foreground font-caption">معدل الاستجابة</span>
              <span className="text-base md:text-lg font-heading font-semibold text-success">92%</span>
            </div>
            <div className="w-full h-1.5 md:h-2 bg-background rounded-full overflow-hidden">
              <div className="h-full bg-success rounded-full" style={{ width: '92%' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelSidebar;